<template>
  <div>
    <CustomTitle class="title" zh="我们的产品" en="PRODUCT" />
    <div class="card">
      <tabs selected="lxbird">
        <div class="bg-circle-img at-right-bottom"></div>
        <div class="bg-circle-img at-left-top"></div>
        <tabs-head>
          <tabs-item name="lxbird" class="wow fadeInDown" data-wow-delay="0.1s"
            ><ProductIcon icon-name="lxbird" name="LXBIRD留学鸟"
          /></tabs-item>
          <tabs-item name="hkok" class="wow fadeInDown" data-wow-delay="0.3s"
            ><ProductIcon icon-name="hkok" name="香不香港"
          /></tabs-item>
          <tabs-item name="woflat" class="wow fadeInDown" data-wow-delay="0.5s"
            ><ProductIcon icon-name="woflat" name="小窝公寓Woflat"
          /></tabs-item>
          <tabs-item name="simcard" class="wow fadeInDown" data-wow-delay="0.7s"
            ><ProductIcon icon-name="simcard" name="大K卡"
          /></tabs-item>
          <tabs-item name="plus" class="wow fadeInDown" data-wow-delay="0.7s"
            ><ProductIcon icon-name="plus" name="Plus 求职"
          /></tabs-item>
        </tabs-head>
        <tabs-body>
          <tabs-pane name="lxbird">
            <h3 class="">LXBIRD留学鸟</h3>
            <p class="product-detail">
              “Lxbird留学鸟”
              智能化留学申请平台成立于2018年初，是国内首个提出DIT留学申请模式的线上服务平台，
              将互联网思维注入留学服务当中，革新了传统留学咨询服务严重同质化和线下低效的服务体验，
              让用户拥有更大的选择权和参与感。 全新的 Do It Together 【DIT
              模式】，把留学服务拆分重组，重新定义。
              自主选择所需服务、自由组合产品任务，与服务管家一起完成最精准的定制化留学申请，线上实时跟踪进度。
              “留学鸟”平台已与上百家国外名校有合作对接，覆盖英国、澳洲、香港等热门留学目的地。
            </p>
            <div class="button-wrapper">
              <BaseButton href="https://www.lxbird.com" />
            </div>
          </tabs-pane>
          <tabs-pane name="hkok"
            ><h3 class="">HKOK香不香港</h3>
            <p class="product-detail">
              香港作为第一个留学目的地服务平台模式的试点，我们建立了第一款在地服务平台产品-香不香港：
              提供各项切合留学生需求的物流、生活、工作、旅游等留学在地服务。“HKOK香不香港”平台经过多年的发展，
              已经在iOS、Android、H5、PC、微信等多个客户端上线，活跃留学生人数达5万+，月PV超70万，
              已成为香港地区最大的留学服务平台与留学生社区！通过对接第三方优质服务商、自营服务、自营学生公寓等，
              打造了一个覆盖整个留学后市场的服务生态闭环。
            </p>
            <div class="button-wrapper">
              <BaseButton href="https://www.offerhk.com" />
            </div>
          </tabs-pane>
          <tabs-pane name="woflat"
            ><h3 class="">小窝公寓Woflat</h3>
            <p class="product-detail">
              Woflat小窝公寓–独立服务式公寓品牌创立于2019年初，我们根据留学生对于目的地住宿的各类需求，
              以及多年积累的留学生平台运营经验，推出了拎包入住的管家式服务的学生公寓。Woflat小窝公寓已经在覆盖香港各大学校区，
              提供200+个公寓位置，并开发了基于微信小程序的线上公寓管理系统。Woflat小窝公寓即将推出英国、澳洲的学生公寓项目，
              覆盖更多留学目的地。
            </p>
            <div class="button-wrapper">
              <BaseButton href="http://woflat.com" />
            </div>
          </tabs-pane>
          <tabs-pane name="simcard"
            ><h3 class="">大K卡</h3>
            <p class="product-detail">
              联合留学目的地各大电讯运营商，打造与国内类似的“无需签约、随充随用”留学生定制电话卡
              – 大K卡：
              全速4.5G的大流量套餐、灵活的月租模式、国内漫游数据流量、随时叠加的各类流量包、兼具低于市场价的月费，
              完美满足留学生在目的地中短期的电话上网需求，打造留学生版专属的“大王卡”！
            </p>
            <div class="button-wrapper">
              <BaseButton href="http://dak.offerhk.com" />
            </div>
          </tabs-pane>
          <tabs-pane name="plus"
            ><h3 class="">Plus 求职</h3>
            <p class="product-detail">
              Plus求职成立于2021年，品牌定位为专注于留学生一站式求职
              的求职服务提供商，面向数十万海归的中国留学生提供一个合适且有发展空间的工作岗位。从2021年开始，Plus求职在中国已经服务了5000多名留学生，达成合作的企业覆盖香港、北京、上海、广州、深圳及一众新一线、及其他大湾区城市。Plus求职小程序已于2021年秋季正式上线，学生可以直接投递职位、订阅秋招时间推送、查看求职攻略、简历润色修改、实习内推、导师指导等一站式功能，留学生还能选择各类人才及政策咨询服务，平台每年定期举办Plus系列春秋招线上/线下招聘季活动！
            </p>
            <div class="button-wrapper">
              <BaseButton href="https://plus.offerhk.com" />
            </div>
          </tabs-pane>
        </tabs-body>
      </tabs>
    </div>
  </div>
</template>

<script>
import Tabs from "./common/tabs";
import TabsHead from "./common/tabs-head";
import TabsItem from "./common/tabs-item";
import TabsBody from "./common/tabs-body";
import TabsPane from "./common/tabs-pane";
import ProductIcon from "./ProductIcon";
import CustomTitle from "../components/common/CustomTitle";
import BaseButton from "../components/common/BaseButton";
import { WOW } from "wowjs";

export default {
  name: "Products",
  components: {
    Tabs,
    TabsHead,
    TabsItem,
    TabsBody,
    TabsPane,
    ProductIcon,
    CustomTitle,
    BaseButton,
  },
  mounted() {
    this.$nextTick(() => {
      const wow = new WOW({
        live: false,
      });
      wow.init();
    });
  },
};
</script>

<style scoped lang="scss">
.title {
  width: 1279px;
  margin: 0 auto;
}

.button-wrapper {
  text-align: right;
}
.card {
  position: relative;
  border-radius: 20px;
  margin: 0 auto;
  padding: 66px 183px;
  box-shadow: 0 19px 30px rgba(167, 168, 175, 0.2);
  width: 1279px;
  box-sizing: border-box;
}
.product-detail {
  color: #7a7a7a;
  font-size: 14px;
}
.bg-circle-img {
  background-image: url("../assets/background-circle.svg");
  position: absolute;
  width: 165px;
  height: 236px;
  overflow: hidden;

  &.at-right-bottom {
    right: 0;
    bottom: 0;
  }

  &.at-left-top {
    transform: rotate(180deg);
    top: 0;
    left: 0;
  }
}
</style>
